import React from 'react';
import AppContent from './AppContent';
import LoginContextProvider from './contexts/LoginContext';

const App = () => {
  return (
    <LoginContextProvider>
      <AppContent />
    </LoginContextProvider>
  );
};
export default App;
